import { render, staticRenderFns } from "./purchase_order.vue?vue&type=template&id=6d2a9ddb&scoped=true&"
import script from "./purchase_order.vue?vue&type=script&lang=js&"
export * from "./purchase_order.vue?vue&type=script&lang=js&"
import style0 from "./purchase_order.vue?vue&type=style&index=0&id=6d2a9ddb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a9ddb",
  null
  
)

export default component.exports